import {userOrm} from '@/utils/orm-tools/user'
import {userHistoryOrm} from '@/utils/orm-tools/userHistory'
import {UserState} from '@/utils/user/constants'

import {UserFragment} from '../graphqlSdk'

// Kept free of client-touching imports so App Router route handlers can use it
export const getUserByEmailHistoryIncluded = async (
  email: string,
  status?: UserState,
): Promise<UserFragment | null> => {
  const lowerCaseEmail = email.toLowerCase()

  const users = await userOrm.getMany({
    email: {_eq: lowerCaseEmail},
    ...(status ? {status: {_eq: status}} : {}),
  })

  if (users.length > 0) {
    return users[0]
  }

  const usersHistory = await userHistoryOrm.getMany({
    email: {_eq: lowerCaseEmail},
  })

  return usersHistory.length > 0 ? await userOrm.getById(usersHistory[0].user_id) : null
}

export const getUserExists = async (email: string, status?: UserState): Promise<boolean> =>
  (await getUserByEmailHistoryIncluded(email, status)) !== null
